<template>
<v-card style="width:1200px">
  <v-toolbar flat height="42">
    <v-toolbar-title>
      <v-avatar size="29">
        <img :src="accounts.sender.photo_50">
      </v-avatar>
      <a style="text-decoration:none;color:#273C51"  target="_blank" v-bind ='{href: "http://vk.com/id"+accounts.sender.info.vk_id}'>
      <span style="margin:5px">{{accounts.sender.first_name}}</span>
      <span>{{accounts.sender.last_name}}</span>
      </a>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="accounts.modals.msg = false">mdi-close</v-icon>
  </v-toolbar>

  <v-card-text >
    <v-layout justify-center style="min-height:100vh">
   <messages :init="init"></messages>
    </v-layout>
  </v-card-text>

</v-card>
</template>

<script>
import messages from '../../proc/msg/msg.vue'
import axios from 'axios'
export default {
props:['accounts'],
components:{messages},
  data () {
    return {
  init: {
    type: 'getBySenderWithOffset',
    limit: 5,
    offset:0,
    senderId: this.accounts.sender.info.vk_id,
  },

    }
  },
methods:{


},
created(){
//  this.init.senderId = this.accounts.sender.info.vk_id
},

}
</script>

<style   >

</style>
